<div class="dialog-header mb-4">
  <h2 mat-dialog-title class="px-4" style="left: 10px; width: fit-content;">
    Logout Confirmation
  </h2>
  <div mat-dialog-content class="-p-4">
    <h4 class="log-text">Do you want to Logout ?</h4>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-start px-4 pt-3">
    <button button-login-secondary class="me-3" (click)="dialogRef.close()">Cancel</button>
    <button button-primary-auth (click)="logout()">Confirm</button>
  </div>
</div>